<template>
    <svg
        class="radial-progress"
        viewBox="0 0 100 100"
        :width="diameter"
        :height="diameter"
    >
        <defs>
            <linearGradient :id="gradientId" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" :stop-color="startColor" />
                <stop offset="100%" :stop-color="stopColor" />
            </linearGradient>
        </defs>
        <circle
            class="radial-progress__trail"
            cx="50"
            cy="50"
            :r="radius"
            :stroke="innerStrokeColor"
            fill="none"
            :stroke-width="innerStrokeWidth"
        />
        <circle
            class="radial-progress__indicator"
            cx="50"
            cy="50"
            :r="radius"
            fill="none"
            :stroke-dasharray="circumference"
            :stroke-dashoffset="dashOffset"
            :stroke="`url(#${gradientId})`"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
    </svg>
</template>

<script>
let gradientSeed = 0;

export default {
    name: 'RadialProgressBar',
    props: {
        diameter: {
            type: Number,
            default: 40,
        },
        completedSteps: {
            type: Number,
            default: 0,
        },
        totalSteps: {
            type: Number,
            default: 1,
        },
        strokeWidth: {
            type: Number,
            default: 4,
        },
        innerStrokeWidth: {
            type: Number,
            default: 4,
        },
        startColor: {
            type: String,
            default: '#57947f',
        },
        stopColor: {
            type: String,
            default: '#57947f',
        },
        innerStrokeColor: {
            type: String,
            default: '#ececec',
        },
    },
    data() {
        gradientSeed += 1;
        return {
            gradientId: `radial-progress-${gradientSeed}`,
        };
    },
    computed: {
        radius() {
            return 50 - Math.max(this.strokeWidth, this.innerStrokeWidth);
        },
        circumference() {
            return 2 * Math.PI * this.radius;
        },
        progressRatio() {
            if (!this.totalSteps) {
                return 0;
            }
            const clamped = Math.min(this.completedSteps, this.totalSteps);
            return clamped / this.totalSteps;
        },
        dashOffset() {
            return this.circumference * (1 - this.progressRatio);
        },
    },
};
</script>

<style scoped>
.radial-progress {
    transform: rotate(-90deg);
}

.radial-progress__trail {
    opacity: 0.35;
}
</style>
